// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let ClaimV1Api = class ClaimV1Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Retrieve Accumulators by Member Number
     * @param memberNumber Member Number
     * @param date Optional date to filter to
     */
    async getByMemberNumber(memberNumber, date) {
        const _url_ = '/claim/v1/Accumulator';
        let _params_ = {};
        let _headers_ = {};
        if (memberNumber !== undefined) {
            _params_['memberNumber'] = Serializer.serialize(memberNumber, "string");
        }
        if (date !== undefined) {
            _params_['date'] = Serializer.serialize(date, "Date");
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimAccumulatorModels");
        }
        return response;
    }
};
ClaimV1Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], ClaimV1Api);
export { ClaimV1Api };
//# sourceMappingURL=claimV1Api.js.map